module.exports = __webpack_public_path__ + "static/img/kabi_quanyi.3386e5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b2c/kabi_quanyi.png
// module id = ftiI
// module chunks = 18